import { createContext, useContext, useMemo } from 'react';
import { useLocalStorage } from './useLocalStorage';
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useLocalStorage('token', null);

  const login = async (token) => {
    if (token) setToken(token);
  };

  const logout = () => {
    setToken(null);
    localStorage.removeItem('user');
  };

  const value = useMemo(
    () => ({
      token,
      login,
      logout,
    }), // eslint-disable-next-line
    [token]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
